import React from "react";
import {makeStyles, TableCell, TableRow, Typography} from "@material-ui/core";
import PropTypes from "prop-types";
import Tr from "translations/Translations";
import TextInput from "components/TextInput";
import INPUT_TYPE from "constants/INPUT_TYPE";
import GridBlock from "components/GridBlock";
import Checkbox from "components/Checkbox";
import getObjectValue from "libs/getObjectValue";
import NetGrossCalc from "components/complex/netGrossCalc/NetGrossCalc";

const useStyles = makeStyles(theme => ({
    cancelColumn: {
        textAlign: 'center'
    },
    cell: {
        padding: theme.spacing()
    },
    valueInput: {
        width: 150
    },
    italic: {
        fontStyle: 'italic'
    }

}));

function DemandPlanRealizationRow(
    {
        demandId,
        index,
        editable,
        realization,
        formikProps,
        passiveOfferForm,
        exPost
    }) {

    const classes = useStyles();
    const isCancelled = getObjectValue(`${index}.canceled`, formikProps.values, false)


    return (<TableRow>
        <TableCell className={classes.cell}>{index + 1}.</TableCell>
        <TableCell className={classes.cell}>{realization.dealingName}</TableCell>
        <TableCell className={classes.cell}>
            <Typography variant='body1'>{realization.planItemName}</Typography>
            <Typography className={classes.italic} variant='body2'>{realization.planItemNumber}</Typography>
        </TableCell>
        <TableCell className={classes.cell}>
            <GridBlock
                justify='space-between'>
                <TextInput
                    className={classes.valueInput}
                    formikProps={formikProps}
                    id={`${index}.realizationValue`}
                    label={Tr('plan_item_realization_net')}
                    type={INPUT_TYPE.NUMBER_19}
                    step="0.01"
                    disabled={isCancelled || !editable}
                    onChange={() => formikProps.setFieldValue(`${index}._touched`, true)}
                />
                <NetGrossCalc
                    disabled={isCancelled || !editable}
                    netValue={getObjectValue(`${index}.realizationValue`, formikProps.values, "")}
                    setNetValue={(value) => {
                        formikProps.setFieldValue(`${index}.realizationValue`, value);
                        formikProps.setFieldValue(`${index}._touched`, true)
                    }}
                    setGrossValue={(value) => {
                        formikProps.setFieldValue(`${index}.realizationGrossValue`, value);
                        formikProps.setFieldValue(`${index}._touched`, true)
                    }}
                    grossValue={getObjectValue(`${index}.realizationGrossValue`, formikProps.values, "")}

                />
                <TextInput
                    className={classes.valueInput}
                    formikProps={formikProps}
                    id={`${index}.realizationGrossValue`}
                    label={Tr('plan_item_realization_gross')}
                    type={INPUT_TYPE.NUMBER_19}
                    step="0.01"
                    disabled={isCancelled || !editable}
                    onChange={() => formikProps.setFieldValue(`${index}._touched`, true)}
                />
            </GridBlock>
        </TableCell>
        {(!!passiveOfferForm || !!exPost) &&
            <TableCell className={classes.cancelColumn}>
                <Checkbox
                    formikProps={formikProps}
                    id={`${index}.canceled`}
                    disabled={!editable}
                    tooltip='invalidate'
                    onChange={() => formikProps.setFieldValue(`${index}._touched`, true)}
                />
            </TableCell>}
    </TableRow>)
}

DemandPlanRealizationRow.propTypes = {
    index: PropTypes.number.isRequired,
    realization: PropTypes.shape({
        realizationId: PropTypes.number.isRequired
    }),
    editable: PropTypes.bool.isRequired,
    passiveOfferForm: PropTypes.bool.isRequired,
    exPost: PropTypes.bool.isRequired,
    demandId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export default DemandPlanRealizationRow;

